import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Catalog } from './components/Catalog';
import { About } from './components/About';
import { Authors } from './components/Authors';
import { Policies } from './components/Policies';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-paper" data-id="element-0" data-mp="2rk45b0t1quff">
      <Navbar data-id="element-1" data-mp="2rit2b37fdqpd" />
      <main data-id="element-2" data-mp="2rikrdguv4vgt">
        <Hero data-id="element-3" data-mp="2mm2o6lf6l56l" />
        <Catalog data-id="element-4" data-mp="2mmlsv0ftlx2o" />
        <About data-id="element-5" data-mp="2mn5bykh7iria" />
        <Authors data-id="element-6" data-mp="2mndna7xolord" />
        <Policies data-id="element-7" data-mp="2mjpyfm36lqiz" />
        <Contact data-id="element-8" data-mp="31agmqk5ke7hc" />
      </main>
      <Footer data-id="element-9" data-mp="31bs1tg4gn1nr" />
    </div>;
}